<script async setup lang="ts">
import 'swiper/css'
import 'swiper/css/navigation'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'

const props = defineProps<{
  images: string[]
}>()

const navigation = {
  nextEl: '.swiper-button-next',
  prevEl: '.swiper-button-prev'
}
</script>

<template>
  <Swiper :modules="[Navigation]" :navigation="navigation" :allow-touch-move="false" :loop="true" :centered-slides="true" class="swiper relative">
    <SwiperSlide v-for="(image, index) in props.images" :key="index">
      <div class="relative h-full w-full">
        <img class="aspect-video h-full w-full cursor-pointer rounded-bl rounded-tl object-cover" :src="image" />
        <div class="pointer-events-none absolute inset-y-0 left-0 w-[70px] bg-gradient-to-r from-black/20 to-transparent opacity-100"></div>
        <div class="pointer-events-none absolute inset-y-0 right-0 w-[70px] bg-gradient-to-l from-black/20 to-transparent opacity-100"></div>
      </div>
    </SwiperSlide>
    <div class="swiper-button-prev -full"></div>
    <div class="swiper-button-next -full"></div>
  </Swiper>
</template>

<style scoped>
.swiper {
  width: 100%;
  height: 100%;
}

.swiper-button-prev {
  --swiper-navigation-size: 25px;
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  height: 100%;
  width: 2.5rem;
  color: #fff;
  transition: opacity 0.3s;
  margin-top: 0;
}
.swiper-button-next {
  --swiper-navigation-size: 25px;
  position: absolute;
  bottom: 0;
  top: 0;
  right: 0;
  height: 100%;
  width: 2.5rem;
  color: #fff;
  transition: opacity 0.3s;
  margin-top: 0;
}
.swiper-button-prev.-full {
  width: 50%;
  display: flex;
  justify-content: start;
  padding-left: 1em;
}
.swiper-button-next.-full {
  width: 50%;
  display: flex;
  justify-content: end;
  padding-right: 1em;
}
.swiper-button-prev.swiper-button-disabled,
.swiper-button-next.swiper-button-disabled {
  opacity: 0.45;
  pointer-events: all;
}
</style>
